module.exports = {
  SCAM: 'SCAM',
  ACCOUNT_TAKEOVER: 'ACCOUNT_TAKEOVER',
  COERCION: 'COERCION',
  FRAUDULENT_ACCESS: 'FRAUDULENT_ACCESS',
  OTHER: 'OTHER',
  UNKNOWN: 'UNKNOWN'
};
